<div class="container-video-chamada">
    <div class="video-call">
        <div class="video-card">
            <div class="video-card-header">
                <h5>Consulta</h5>
                <app-video-call-options></app-video-call-options>
            </div>
            <div class="video-card-body">

                <div class="videos">
                    <div id="subscriber" class="remote-video">

                    </div>

                    <div class="local-video" [ngClass]="{ 'waiting-remote': isAlone }">
                        <div id="publisher" class="local-video-content"></div>
                        <div class="waiting-remote-content">
                            <p>{{ waitingText }}</p>
                        </div>
                    </div>
                </div>

                <div class="controls">
                    <button class="btn btn-sm btn-light" (click)="toggleRemoteAudio()">
                        <i [ngClass]="remoteAudioMuted ? 'fa fa-volume-mute' : 'fa fa-volume-up'"></i>
                    </button>

                    <button class="btn btn-sm btn-light" (click)="toggleAudio()">
                        <i [ngClass]="audioEnabled ? 'fa fa-microphone' : 'fa fa-microphone-slash'"></i>
                    </button>

                    <button class="btn btn-sm btn-danger" (click)="leaveCall()">
                        <i class="fa fa-phone-slash"></i>
                    </button>

                    <button class="btn btn-sm btn-light" (click)="toggleVideo()">
                        <i [ngClass]="videoEnabled ? 'fa fa-video' : 'fa fa-video-slash'"></i>
                    </button>

                    <button class="btn btn-sm btn-light" (click)="toggleFullscreen()">
                        <i class="fa fa-expand"></i>
                    </button>
                </div>
            </div>


        </div>


    </div>

    <div class="consulta">
        <card-consulta [consulta]="consulta"></card-consulta>
    </div>
</div>
